module.exports = __webpack_public_path__ + "assets/setting.8fd4c557.svg";